export default [
    {
        path: 'reimpressao-resultado',
        component: () => import(
            /* webpackChunkName: 'exame-imagem-reimpressao-resultado' */
            '@/views/exame-imagem/reimpressao-resultado/Index'
        ),
        redirect: 'reimpressao-resultado/index',
        children: [
            {
                name: 'exame-imagem-reimpressao-resultado-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'exame-imagem-reimpressao-resultado' */
                    '@/views/exame-imagem/reimpressao-resultado/List'
                ),
            },
        ]
    }
]